import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/packing_house_process/${packing_house_process_id}`
    );
  },
  fetchHarvestedBatches(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/list/${packing_house_process_id}`
    );
  },
  fetchHarvestedBatch(harvested_batch_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/harvested_batch/${harvested_batch_id}`
    );
  },
  create(packing_house_process_id, harvested_batch) {
    return RequesterV1.post(
      `packing_house/process/harvested_batches/create/${packing_house_process_id}`,
      { harvested_batch: harvested_batch }
    );
  },
  update(harvested_batch_id, harvested_batch) {
    return RequesterV1.post(
      `packing_house/process/harvested_batches/update/${harvested_batch_id}`,
      { harvested_batch: harvested_batch }
    );
  },
  destroy(harvested_batch_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/destroy/${harvested_batch_id}`
    );
  }
};
